// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CustomerTriage,
  customerTriageSchema,
} from '@/customer/api/triage-types';

interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

interface NewCustomerRequest {
  name: string;
  isCustomer: boolean;
  isSupplier: boolean;
  domain?: string | null;
  billingAddress?: string | null;
  billingContact?: {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
  };
}

interface ClassifyCustomerTriageRequest {
  customerId?: string;
  newCustomer?: NewCustomerRequest;
}

export async function classifyTriageCustomer(
  triageKey: string,
  request: ClassifyCustomerTriageRequest
): Promise<CustomerTriage> {
  const url = `/v1/customer-triage/${triageKey}/classify`;
  const response = await api.post<ApiResponse>(url, request);

  return parseResponse(customerTriageSchema, response.data.data, {
    schemaName: 'ClassifyTriageCustomer',
    endpoint: url,
  });
}
